import { render, staticRenderFns } from "./UpdateEmailDialog.vue?vue&type=template&id=3944a532&"
import script from "./UpdateEmailDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateEmailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports